export const clientThemes: Record<string, Record<string, string>> = {
  SGS: {
    "--primary-color": "#ff6600",
    "--custom-primary-color": "#3c505a", //for table header background
    "--link-color": "#ff8533",
    "--border-color-base": "#ff6600",
    "--background-color": "#fff5eb",
    "--error-color": "#ff4d4f",
    "--warning-color": "#fa8c16",
    "--success-color": "#52c41a",
    "--highlight-color": "#ff6600",
    "--primary-1": "#fff0e6", // very light
    "--primary-5": "#ff944d", // medium
    "--primary-6": "#ff6600", // base
    "--warn-color": "#fa8c16",
    "--warn-5": "#ffb84d",
    "--background-color-base": "#fff2e6",
    "--label-color": "rgba(0, 0, 0, 0.75)",
    "--heading-5-size": "16px",
    "--font-family": "Arial",
  },
};
